// Users API client (Phase 7).
import { request } from './api';

export const usersApi = {
    list: () => request('/users'),
    create: (body) => request('/users', { method: 'POST', body }),
    update: (id, body) => request(`/users/${id}`, { method: 'PATCH', body }),
    deactivate: (id) => request(`/users/${id}/deactivate`, { method: 'PATCH' }),
};
